"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_METHOD_WINDOW_SECONDS = exports.LOGIN_METHOD_MAGIC_LINK = exports.LOGIN_METHOD_HEADER_NAME = void 0;
/**
 * Cross-workspace contract for disambiguating magic-link from email/password logins.
 *
 * Firebase reports BOTH email/password and email-link (magic-link) sign-ins as
 * `sign_in_provider === 'password'`, so the two are indistinguishable from the decoded token alone.
 * The web app stamps this short-lived request header on a magic-link sign-in and the server's auth
 * guard reads it to record the correct login method in the audit log.
 *
 * It travels as a request header rather than a cookie because the API is a different origin than the
 * web app in every environment (a different port locally, an `*.api.neo.tax` subdomain in
 * staging/production). A host-only cookie set on the web-app origin is never sent to `/graphql`, so
 * the cookie this replaces always read as empty server-side and every magic-link login mis-recorded
 * as EMAIL_PASSWORD. Custom request headers ride cross-origin under the API's `origin: '*'` CORS, the
 * same way the existing `version` header already does.
 *
 * The value is client-supplied, so it is an audit-quality hint, not a security control — a caller
 * could stamp it on any login. That trust level is identical to the cookie it replaces.
 */
// Lowercase: HTTP header names are case-insensitive and Express exposes them lowercased.
exports.LOGIN_METHOD_HEADER_NAME = 'x-login-method';
exports.LOGIN_METHOD_MAGIC_LINK = 'magic_link';
// The web app keeps stamping the header for this window after a magic-link sign-in — long enough to
// cover the audit log's 60s fresh-login window — then stops.
exports.LOGIN_METHOD_WINDOW_SECONDS = 62;
